import { useState } from 'react'
import { Button, Divider, Input, Typography, Form } from 'antd'
import { saveEditCharacter } from 'src/api/user'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
const { Title, Text } = Typography
import './EditCharacter.css'

const EditCharacter = () => {
  const { id } = useParams()
  const location = useLocation()

  const params = new URLSearchParams(location.search)

  const [editedImg, setEditedImg] = useState(params.get('img'))
  const [editedThumbImg, setEditedThumbImg] = useState(params.get('thumbImg'))
  const [newImage, setNewImage] = useState(null)
  const [newThumbImage, setNewThumbImage] = useState(null)
  const [enabled, setEnabled] = useState(params.get('enabled') === 'true')

  const navigate = useNavigate()

  const [form] = Form.useForm()

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      const imageUrl = URL.createObjectURL(file)
      setNewImage(file)
      setEditedImg(imageUrl)
    }
  }

  const handleSave = async () => {
    const values = await form.validateFields()
    saveEditCharacter(
      id,
      values.editedName,
      values.editedDesc,
      newImage,
      newThumbImage,
      enabled
    ).then(() => {
      navigate('/characters/main')
    })
  }

  const onCancel = () => {
    navigate('/characters/main')
  }

  const handleThumbImageUpload = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      const imageUrl = URL.createObjectURL(file)
      setNewThumbImage(file)
      setEditedThumbImg(imageUrl)
    }
  }

  return (
    <div className="edit-character-container">
      <Title level={3}>
        <Text>Edit Character</Text>
      </Title>
      <Divider />
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 20 }}
      >
        <Form.Item
          label="Name"
          name="editedName"
          initialValue={params.get('name')}
          rules={[{ required: true, message: 'Please enter the title' }]}
        >
          <Input placeholder="Title" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="editedDesc"
          initialValue={params.get('desc')}
          rules={[{ required: true, message: 'Please enter the description' }]}
        >
          <Input.TextArea placeholder="Description" />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0 }}>
          <Button
            onClick={() => document.getElementById('upload-image')?.click()}
            className="edit-img-button"
          >
            Edit Image
          </Button>
          <input
            id="upload-image"
            type="file"
            hidden
            accept="image/*"
            onChange={handleImageUpload}
          />
          <Button
            onClick={() => document.getElementById('upload-thumbnail')?.click()}
            className="edit-thumb-button"
          >
            Edit Thumbnail
          </Button>
          <input
            id="upload-thumbnail"
            type="file"
            hidden
            accept="image/*"
            onChange={handleThumbImageUpload}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 0 }}>
          <div className="image-preview">
            <img src={editedImg} alt="Edited Image" />
            <img
              src={editedThumbImg}
              alt="Edited Thumbnail"
              className="thumb-img"
            />
          </div>
        </Form.Item>
        <div className="button-container" style={{ marginTop: 16 }}>
          <Button className="save-button" onClick={handleSave}>
            Save
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </div>
      </Form>
    </div>
  )
}

export default EditCharacter
